const useLocal = process.env.REACT_APP_USE_LOCAL_SUPABASE === 'true';

export const REACT_APP_SUPABASE_URL = useLocal
  ? process.env.REACT_APP_LOCAL_SUPABASE_URL
  : process.env.REACT_APP_SUPABASE_URL;

export const REACT_APP_SUPABASE_ANON_KEY = useLocal
  ? process.env.REACT_APP_LOCAL_SUPABASE_ANON_KEY
  : process.env.REACT_APP_SUPABASE_ANON_KEY;

export const REACT_APP_API_KEY = REACT_APP_SUPABASE_ANON_KEY;

export const DEFAULT_AVATARS_BUCKET = 'related-files';

export type Profile = {
  id: string;
  avatar_url: string;
  username: string;
  website: string;
  updated_at: string;
};
